export const BOOLEAN = 'BOOLEAN';
export const DATE = 'DATE';
export const DROPDOWN = 'DROPDOWN';
export const NUMBER = 'NUMBER';
export const TEXT = 'TEXT';
